import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation Create($data: CreateInvestmentInfoInput!) {
    createInvestmentInfo(data: $data) {
      id
    }
  }
`);

export const responseCreateKey = "createInvestmentInfo";
export interface CreateGql {
  createInvestmentInfo: {
    id: number;
  };
}
